/* jslint browser: true */
/* global window document */
import React, { Component } from 'react';
import axios from 'axios';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import { apiUrl } from '../lib/constants';

class FormProgramme extends Component {
    constructor(props) {
        super(props);
        this.state = {
            programme: {
                id_pro: 0,
                id_probleme1: 0,
                id_biotypologie: 0,
                // id_probleme2 : 0,
                genre: '',
                nom: '',
                prenom: '',
                age: 0,
                taille: 0,
                duree: 0,
                poids: 0,
                nomFichier: '',
                email: '',
                sendMail: false
            },
            problemes: [],
            biotypologies: [],
            isOpenModal: true,
            isOpenModalConfirm: false,
            isOpenModalCredit: false,
            pro: {
                email: '',
                etablissement: '',
                genre: '',
                nom: '',
                prenom: '',
                adresse: '',
                postal: '',
                ville: '',
                telephone: '',
                siret: ''
            },
            pdfLink: '',
            generationLoading: false,
            id_pro: 0
        };
        this.handleChange = this.handleChange.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.confirmProgramme = this.confirmProgramme.bind(this);
        this.reloadPage = this.reloadPage.bind(this);
    }

    componentWillMount() {
        this.loadRadios();
        axios
            .post(`${apiUrl}/api/v1/getUserFromToken`, {
                token: window.localStorage.getItem('token')
            })
            .then(response => {
                if (response.data === undefined) {
                    return;
                }
                const programme = this.state.programme;
                programme.id_pro = response.data.id_pro;
                this.setState({
                    programme,
                    pro: response.data,
                    id_pro: response.data.id_pro
                });

                // si le pro n'as plus de credit(s), on lui lock le form
                if (this.state.pro.credit < 1) {
                    toast.error('Crédits insuffisant', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    const form = document.querySelector('#programme');
                    for (let i = 0; i < form.length; i += 1) {
                        form[i].disabled = true;
                    }
                } else if (this.state.pro.credit < 4) {
                    this.setState({ isOpenModalCredit: true });
                }
            })
            .catch(() => {});
    }

    loadRadios() {
        axios.get(`${apiUrl}/api/v1/probleme`).then(response => {
            axios.get(`${apiUrl}/api/v1/biotypologie`).then(_response => {
                this.setState({
                    problemes: response.data,
                    biotypologies: _response.data
                });
            });
        });
    }

    /**
     * Permet de fermer la popup de responsabilité
     */
    closeModal() {
        this.setState({ isOpenModal: false });
    }

    reloadPage() {
        this.setState({
            programme: {
                id_pro: this.state.id_pro,
                id_probleme1: 0,
                id_biotyplogie: 0,
                // id_probleme2 : 0,
                genre: '',
                nom: '',
                prenom: '',
                age: 0,
                taille: 0,
                duree: 0,
                poids: 0,
                nomFichier: '',
                email: '',
                sendMail: false
            },
            isOpenModal: false,
            isOpenModalConfirm: false,
            isOpenModalCredit: false,
            pdfLink: '',
            generationLoading: false,
            problemes: [],
            biotypologies: []
        });
        this.loadRadios();
    }

    /**
     * Mes a jour un champ du menu en fonction de l'element HTML modifié
     * @param  {event} e Evenement (onChange) sur un champ du formulaire
     */
    handleChange(e) {
        const programme = this.state.programme;
        programme[e.target.name] = e.target.value;
        this.setState({
            programme
        });
    }

    /**
     * ouvre la popup de confirmation
     */
    submitProgramme(e) {
        e.preventDefault();
        const validation = [
            { field: 'genre', label: 'genre', required: true },
            { field: 'nom', label: 'nom', required: true },
            { field: 'prenom', label: 'prénom', required: true },
            {
                field: 'age',
                label: 'âge',
                required: true,
                min: 15,
                max: 70
            },
            { field: 'taille', label: 'taille', required: true },
            { field: 'poids', label: 'poids', required: true },
            {
                field: 'id_probleme1',
                label: 'problème esthétique',
                required: true
            },
            { field: 'id_biotypologie', label: 'biotypologie', required: true }
        ];

        let isValid = true;
        let i = 0;

        while (isValid && i < validation.length) {
            if (
                validation[i].required &&
                !this.state.programme[validation[i].field]
            ) {
                toast.error('Le champ ' + validation[i].label + ' est requis.');
                isValid = false;
            } else if (
                validation[i].min !== undefined &&
                this.state.programme[validation[i].field] < validation[i].min
            ) {
                toast.error(
                    'La valeur du champ ' +
                        validation[i].label +
                        ' ne peut pas être inférieure à ' +
                        validation[i].min +
                        '.'
                );
                isValid = false;
            } else if (
                validation[i].max !== undefined &&
                this.state.programme[validation[i].field] > validation[i].max
            ) {
                toast.error(
                    'La valeur du champ ' +
                        validation[i].label +
                        ' ne peut pas être supérieure à ' +
                        validation[i].max +
                        '.'
                );
                isValid = false;
            }
            i++;
        }

        if (isValid) {
            this.setState({ isOpenModalConfirm: true });
        }
    }

    /**
     * Envoie le formulaire a l'api
     */
    confirmProgramme() {
        this.setState({ generationLoading: true });
        axios
            .post(`${apiUrl}/api/v1/programme`, this.state.programme)
            .then(response => {
                this.setState({ generationLoading: false });
                if (response.data === 'Mail') {
                    this.setState({ isOpenModalConfirm: false });
                    toast.success('Programme sauvegardé et envoyé par mail', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    this.setState({
                        programme: {
                            id_pro: this.state.id_pro,
                            id_probleme1: 0,
                            id_biotypologie: 0,
                            // id_probleme2 : 0,
                            genre: '',
                            nom: '',
                            prenom: '',
                            age: 0,
                            taille: 0,
                            duree: 0,
                            poids: 0,
                            nomFichier: '',
                            email: '',
                            sendMail: false
                        },
                        isOpenModal: false,
                        isOpenModalConfirm: false,
                        isOpenModalCredit: false,
                        pdfLink: '',
                        problemes: [],
                        biotypologies: []
                    });
                    this.loadRadios();
                } else {
                    this.setState({ pdfLink: response.data });
                }
            })
            .catch(err => {
                this.setState({ generationLoading: false });
            });
    }

    render() {
        return (
            <div className="programme-form">
                <Modal
                    isOpen={this.state.isOpenModalConfirm}
                    onRequestClose={() => {
                        this.setState({ isOpenModalConfirm: false });
                    }}
                    onRequestOpen={() => {
                        this.setState({ isOpenModalConfirm: true });
                    }}
                    shouldCloseOnOverlayClick={false}
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0.75)',
                            zIndex: 9
                        },
                        content: {
                            position: 'absolute',
                            border: '1px solid rgb(204, 204, 204)',
                            background: 'rgb(249, 249, 249)',
                            overflow: 'auto',
                            borderRadius: '4px',
                            outline: 'none',
                            padding: '0',
                            bottom: 'unset',
                            maxHeight: '95vh',
                            textAlign: 'left',
                            width: '100%',
                            maxWidth: '600px',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)'
                        }
                    }}
                >
                    <div id="confirm-programme">
                        <h3>Confirmation de génération</h3>
                        {!this.state.pdfLink && (
                            <p>
                                Vous êtes sur le point de générer un programme
                                personnalisé pour 1 crédit.<br />Celui-ci sera
                                deduit de votre compte.
                            </p>
                        )}
                        {!this.state.pdfLink &&
                            this.state.programme.email && (
                                <div className="form-row">
                                    <input
                                        type="checkbox"
                                        name="sendMail"
                                        id="sendMail"
                                        onChange={e => this.handleChange(e)}
                                        style={{
                                            width: 'auto',
                                            marginRight: '10px'
                                        }}
                                    />
                                    Cochez cette case pour envoyer le programme
                                    à l&apos;adresse{' '}
                                    <i>{this.state.programme.email}</i>
                                </div>
                            )}
                        {!this.state.pdfLink && (
                            <button
                                className="btn myBtn myBtnCancel pull-left"
                                onClick={() =>
                                    this.setState({ isOpenModalConfirm: false })
                                }
                            >
                                Annuler
                            </button>
                        )}
                        {this.state.pdfLink ? (
                            <a
                                download
                                href={this.state.pdfLink}
                                target="_blank"
                            >
                                Cliquez pour télécharger le programme{' '}
                                <img
                                    src="/pictures/pdf_download.png"
                                    width="70"
                                    alt="pdf-download"
                                />
                            </a>
                        ) : (
                            <button
                                className="btn myBtn pull-right"
                                disabled={
                                    this.state.generationLoading ? 'true' : ''
                                }
                                onClick={e => this.confirmProgramme(e)}
                            >
                                {this.state.generationLoading
                                    ? 'Programmme en cours de génération'
                                    : 'Générer le programme'}
                            </button>
                        )}
                        {this.state.pdfLink && <br />}
                        {this.state.pdfLink && (
                            <button
                                className="btn myBtn myBtnCancel"
                                onClick={e => this.reloadPage()}
                            >
                                Fermer
                            </button>
                        )}
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.isOpenModal}
                    onRequestClose={this.closeModal}
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0.75)',
                            zIndex: 9
                        },
                        content: {
                            position: 'absolute',
                            border: '1px solid rgb(204, 204, 204)',
                            background: 'rgb(249, 249, 249)',
                            overflow: 'auto',
                            borderRadius: '4px',
                            outline: 'none',
                            padding: '0px 10px 0px 10px',
                            bottom: 'unset',
                            maxHeight: '95vh',
                            textAlign: 'center',
                            width: '100%',
                            maxWidth: '900px',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)'
                        }
                    }}
                >
                    <h2>
                        A l&apos;aimable attention de la responsable du centre
                        esthétique et de la clientèle finale.
                    </h2>
                    <br />
                    <p style={{ fontSize: '15px' }}>
                        Ce programme - conseil est élaboré dans le seul but
                        d&apos;am&eacute;liorer les résultats des traitements
                        esthétiques.<br />
                        Il sera réservé exclusivement à des personnes saines,
                        âgées de plus de 15 ans et de moins de 70 ans. Toutes
                        exceptions devront être supervisées et acceptées par le
                        médecin traitant.<br />
                        <br />
                        Le Laboratoire M.G.S. Lucia Rapetti décline toutes
                        responsabilités suite au non-respect de ces normes.
                    </p>
                    <button
                        type="button"
                        className="btn myBtn"
                        onClick={() => this.closeModal()}
                    >
                        OK
                    </button>
                </Modal>
                <Modal
                    isOpen={this.state.isOpenModalCredit}
                    onRequestClose={this.closeModal}
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0.75)',
                            zIndex: 20
                        },
                        content: {
                            position: 'absolute',
                            border: '1px solid rgb(204, 204, 204)',
                            background: 'rgb(249, 249, 249)',
                            overflow: 'auto',
                            borderRadius: '4px',
                            outline: 'none',
                            padding: '0px 10px 0px 10px',
                            bottom: 'unset',
                            maxHeight: '95vh',
                            textAlign: 'center',
                            width: '100%',
                            maxWidth: '900px',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 21
                        }
                    }}
                >
                    <h2>Il vous reste peu de crédits</h2>
                    <br />
                    <p style={{ fontSize: '15px' }}>
                        Il vous reste {this.state.pro.credit} crédits sur votre
                        compte
                    </p>

                    <button
                        type="button"
                        className="btn myBtn pull-right"
                        onClick={() =>
                            this.setState({ isOpenModalCredit: false })
                        }
                    >
                        OK
                    </button>
                    <button
                        type="button"
                        className="btn myBtn pull-left"
                        onClick={() => {
                            window.location.href = '/commande';
                        }}
                    >
                        Obtenir des crédits
                    </button>
                </Modal>
                <div
                    className="lra-box"
                    style={{
                        width: '100%',
                        maxWidth: '900px',
                        margin: '20px auto 0px'
                    }}
                >
                    <div className="lra-box-header">
                        Conseil alimentaire personnalisé
                    </div>
                </div>
                <form style={{ width: '95%', margin: '0 auto' }} id="programme">
                    <div
                        className="border-form"
                        style={{ marginTop: '0px', backgroundColor: '#F9F9F9' }}
                    >
                        <div className="form-row">
                            <div className="form-genre">
                                <label htmlFor="genre">
                                    Genre*
                                    <select
                                        id="genre"
                                        name="genre"
                                        value={this.state.programme.genre}
                                        onChange={e => this.handleChange(e)}
                                    >
                                        <option value="">--</option>
                                        <option value="Homme">Homme</option>
                                        <option value="Femme">Femme</option>
                                    </select>
                                </label>
                            </div>
                            <div className="form-nom">
                                <label htmlFor="nom">
                                    Nom*
                                    <input
                                        type="text"
                                        id="nom"
                                        name="nom"
                                        value={this.state.programme.nom}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </label>
                            </div>
                            <div className="form-prenom">
                                <label htmlFor="prenom">
                                    Prénom*
                                    <input
                                        type="text"
                                        id="prenom"
                                        name="prenom"
                                        value={this.state.programme.prenom}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </label>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-age">
                                <label htmlFor="age">
                                    Âge*
                                    <input
                                        type="number"
                                        id="age"
                                        name="age"
                                        min="15"
                                        max="70"
                                        value={this.state.programme.age}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </label>
                            </div>
                            <div className="form-taille">
                                <label htmlFor="taille">
                                    Taille (cm)*
                                    <input
                                        type="number"
                                        id="taille"
                                        name="taille"
                                        min="50"
                                        value={this.state.programme.taille}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </label>
                            </div>
                            <div className="form-poids">
                                <label htmlFor="poids">
                                    Poids (kg)*
                                    <input
                                        type="number"
                                        id="poids"
                                        name="poids"
                                        min="20"
                                        value={this.state.programme.poids}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </label>
                            </div>
                            <div className="form-email">
                                <label htmlFor="email">
                                    Email
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={this.state.programme.email}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </label>
                            </div>
                        </div>
                        <hr style={{ borderColor: '#000' }} />
                        <div className="form-row">
                            <div className="form-biotypologie">
                                <h4 className="no-style">Biotypologie* :</h4>
                                {this.state.biotypologies.map(biotypologie => (
                                    <div
                                        key={biotypologie.id_biotypologie}
                                        className="biotypologie"
                                    >
                                        <p>{biotypologie.nom}</p>
                                        <input
                                            type="radio"
                                            name="id_biotypologie"
                                            value={biotypologie.id_biotypologie}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                        <hr style={{ borderColor: '#000' }} />
                        <div className="form-row">
                            <div className="form-esthetique">
                                <h4 className="no-style">
                                    Problème Esthétique* :
                                </h4>
                                {this.state.problemes.map(probleme => (
                                    <div
                                        key={probleme.id_probleme}
                                        className="biotypologie"
                                    >
                                        <p>{probleme.nom}</p>
                                        <input
                                            type="radio"
                                            name="id_probleme1"
                                            value={probleme.id_probleme}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <button
                        className="btn myBtn center-block"
                        onClick={e => this.submitProgramme(e)}
                    >
                        Valider *
                    </button>
                    <div
                        style={{
                            fontSize: '11px',
                            textAlign: 'right',
                            marginTop: '50px'
                        }}
                    >
                        * Un crédit est consommé à chaque génération de
                        programme
                    </div>
                </form>
            </div>
        );
    }
}

export default FormProgramme;



// WEBPACK FOOTER //
// ./src/components/FormProgramme.js